import appConstants from "../../../../appConstants";
import { MultiSelectFilter } from '@dataGrid/components/columnFilters';

const CopyIconCellRenderer = () => {
  return <i className="icon-copy pointer-cell"></i>;
};

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.ShipmentsEventStream,
      keyColumn: "Id",
      rowSelection: "single",
      rowDeselection: true,
      defaultColDef: {
        filter: MultiSelectFilter
      },
      columns: [
        {
          headerName: "Id",
          field: "id",
          cellClass: "gridCell-leftAlign",
          minWidth: 220,
          hide: true,
        },
        {
          headerName: "Created DateTime",
          field: "createdDateTime",
          cellClass: "gridCell-leftAlign gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_200,
          maxWidth: appConstants.columnWidth.W_200,
          filter: false,
        },
        {
          headerName: "Type",
          field: "type",
          cellClass: "gridCell-leftAlign gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_150,
          maxWidth: appConstants.columnWidth.W_150,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Status",
          field: "status",
          cellClass: "gridCell-leftAlign gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_100,
          maxWidth: appConstants.columnWidth.W_100,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Error",
          field: "error",
          cellClass: "gridCell-leftAlign gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_150,
          tooltipField: "error",
          suppressSizeToFit: true,
          filter: false,
        },
        {
          headerName: "",
          field: "copyIcon",
          cellClass: "gridCell-leftAlign gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_50,
          maxWidth: appConstants.columnWidth.W_50,
          cellRenderer: CopyIconCellRenderer,
          tooltipValueGetter: () => "Copy data",
          filter: false,
        },
        {
          headerName: "Data",
          minWidth: appConstants.columnWidth.W_250,
          sortable: false,
          cellClass: "gridCell-wrapText",
          valueGetter: (params) => JSON.stringify(params.data.data),
          tooltipValueGetter: (params) => JSON.stringify(params.data.data),
          filter: false,
        },
      ],
    };
  }
}
